import React from 'react';

function PersonalInformation({ user }) {
  return (
    <section className=''>
      <h3 className='font-semibold mb-4 pb-3 border-b-hf'>
        Personal Information
      </h3>
      <p className='flex flex-row justify-between pb-2 gap-2 items-center'>
        <span className='text-s-bk text-sm'> Phone number: </span>
        <span>{user?.phone}</span>
      </p>
      <p className='flex flex-row justify-between pb-2 gap-2 items-center'>
        <span className='text-s-bk text-sm'> Country:</span>
        <span>{user?.country?.name}</span>
      </p>
      <p className='flex flex-row justify-between pb-2 gap-2 items-center'>
        <span className='text-s-bk text-sm'>Organization Email address:</span>
        <span>{user?.email}</span>
      </p>
    </section>
  );
}

export default PersonalInformation;
